export class MapAreaTHENModel {
  code: number;
  areas: string[];
}

export class MapAreaSWPModel {
  code: string;
  area: string;
}

export const MapAreasTHENEnum: MapAreaTHENModel[] = [
  {
    code: 1500,
    areas: ['Gas']
  },
  {
    code: 1501,
    areas: ['Power']
  },
  {
    code: 1502,
    areas: ['Water']
  },
  {
    code: 1503,
    areas: ['Gas', 'Power']
  },
  {
    code: 1504,
    areas: ['Gas', 'Water']
  },
  {
    code: 1505,
    areas: ['Gas', 'Water', 'Power']
  },
  {
    code: 1506,
    areas: ['LWL']
  },
  {
    code: 1507,
    areas: ['Gas', 'LWL']
  },
  {
    code: 1508,
    areas: ['Power', 'LWL']
  },
  {
    code: 1509,
    areas: ['Gas', 'Power', 'LWL']
  },
  {
    code: 1550,
    areas: ['Gas', 'LWLK']
  },
  {
    code: 1551,
    areas: ['Power', 'LWLK']
  },
  {
    code: 1552,
    areas: ['Water', 'LWLK']
  },
  {
    code: 1553,
    areas: ['Gas', 'Power', 'LWLK']
  },
  {
    code: 1554,
    areas: ['Gas', 'Water', 'LWLK']
  },
  {
    code: 1555,
    areas: ['Gas', 'Water', 'Power', 'LWLK']
  },
  {
    code: 1556,
    areas: ['LWL', 'LWLK']
  },
  {
    code: 1557,
    areas: ['Gas', 'LWL', 'LWLK']
  },
  {
    code: 1558,
    areas: ['Power', 'LWL', 'LWLK']
  },
  {
    code: 1559,
    areas: ['Gas', 'Power', 'LWL', 'LWLK']
  }
];

export const MapAreasSWPEnum: MapAreaSWPModel[] = [
  {
    code: 'Strom',
    area: 'Power'
  },
  {
    code: 'Gas',
    area: 'Gas'
  },
  {
    code: 'Wasser',
    area: 'Water'
  },
  {
    code: 'Fernwärme',
    area: 'DistrictHeat'
  }
];

export const MapAreasEVIEnum: MapAreaSWPModel[] = [
  {
    code: 'Strom Niederspannung',
    area: 'Power'
  },
  {
    code: 'Gas',
    area: 'Gas'
  },
  {
    code: 'Wasser',
    area: 'Water'
  },
  {
    code: 'LWL',
    area: 'LWL'
  },
  {
    code: 'Fernwärme',
    area: 'DistrictHeat'
  }
];
